/* The text a `computed` field shows: the server's string or number as it is, or a dash. Never computed here. */

const NOTHING = '—';

/** The server's value as text. Anything that is not a string or a number is "nothing yet". */
export function computedText(value: unknown): string {
  return typeof value === 'string' || typeof value === 'number' ? String(value) : NOTHING;
}
